export default __webpack_public_path__ + "static/media/login-reg-bg.1fb03347.jpg";